import { EXPLORE_ROUTES } from "./exploreRoutes";
import { DASHBOARD_ROUTES } from "./dashboardRoutes";
import { GAMIFICATION_ROUTES } from "./gamification/gamificationRoutes";
import { QUIZ_ROUTES } from "./quizzes/quizRoutes";
import React from "react";
import "./QuickAction.css";
import { useNavigate } from "react-router-dom";
import { buildHeaderQuickActionItems } from "../utils/dashboardStats";
import { getStoredUser } from "../utils/authStorage";
import { CONTENT_ROUTES } from "./contentRoutes";
import { buildQuizBackTarget } from './quizzes/quizFlowState';

const QuickActionCard = ({ item, onClick }) => {
  return (
    <button type="button" className="quick-action-card" aria-label={item.title} onClick={onClick}>
      <span className="quick-action-card__icon" aria-hidden="true">
        {item.image ? (
          <img src={item.image} alt="" className="quick-action-card__icon-image" />
        ) : (
          <i className="fa-solid fa-layer-group" />
        )}
      </span>
      <span className="quick-action-card__title">{item.title}</span>
    </button>
  );
};

const QuickAction = ({ categories = [], isLoading = false, error = "" }) => {
  const navigate = useNavigate();
  const items = buildHeaderQuickActionItems(categories);
  const storedUser = getStoredUser();
  const stateId = storedUser?.state_id || storedUser?.stateId || storedUser?.user_state_id || 0;
  const stateName =
    storedUser?.state_name || storedUser?.stateName || storedUser?.user_state_name || "";
  const selectedState = { state_id: stateId, state_name: stateName };

  const handleActionClick = (item) => {

    if (item.route === QUIZ_ROUTES.list) {
      navigate(item.route, {
        state: {
          selectedState,
          selectedCategory: item.source,
          selectedQuizOption: item.title,
          selectedQuizOptionData: item.source,
          quizBackTarget: buildQuizBackTarget(DASHBOARD_ROUTES.home, {}),
          quizRequestParams: {
            category_id: Number(item?.source?.category_id || item?.source?.id || 1),
            route_key: Number(item?.source?.route_key || 1),
            ...(Number(item?.source?.route_key || 1) === 3
              ? {}
              : {
                  is_quiz:
                    Number(item?.source?.route_key || 1) === 4
                      ? 2
                      : Number(item?.source?.route_key || 1) === 2
                        ? 0
                        : 1,
                }),
          },
        },
      });
      return;
    }

    if (item.route === EXPLORE_ROUTES.subjects || item.route === GAMIFICATION_ROUTES.start || item.route === CONTENT_ROUTES.articles || item.route === CONTENT_ROUTES.dailyQuestions || item.route === "/doubts") {
      navigate(item.route, {
        state: {
          selectedState,
          selectedCategory: item.source,
          gamificationBackTarget:
            item.route === GAMIFICATION_ROUTES.start
              ? {
                  pathname: DASHBOARD_ROUTES.home,
                  state: {},
              }
              : undefined,
          articlesBackTarget:
            item.route === CONTENT_ROUTES.articles
              ? {
                  pathname: DASHBOARD_ROUTES.home,
                  state: {},
                }
              : undefined,
        },
      });
      return;
    }

    navigate(item.route);
  };

  return (
    <section className="quick-action quick-action--grid" aria-labelledby="quick-action-title">
      <div className="quick-action__header">
        <h2 id="quick-action-title" className="quick-action__title">
          What Are You Looking For
        </h2>
      </div>

      {isLoading ? (
        <div className="quick-action__grid" aria-hidden="true">
          {Array.from({ length: 10 }).map((_, index) => (
            <div className="quick-action-card quick-action-card--skeleton" key={index}>
              <span className="dashboard-skeleton quick-action-card__skeleton-icon" />
              <span className="dashboard-skeleton quick-action-card__skeleton-title" />
            </div>
          ))}
        </div>
      ) : null}
      {!isLoading && error ? <p className="quick-action__status quick-action__status--error">{error}</p> : null}
      {!isLoading && !error && items.length === 0 ? (
        <p className="quick-action__status">No quick actions available.</p>
      ) : null}

      {!isLoading && !error && items.length > 0 ? (
        <div className="quick-action__grid">
          {items.map((item) => (
            <QuickActionCard key={item.id} item={item} onClick={() => handleActionClick(item)} />
          ))}
        </div>
      ) : null}
    </section>
  );
};

export default QuickAction;






